import { useEffect } from 'react';

import http from '@/services/api';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectAuth } from '@/store/selectors';
import { signOut } from '@/store/features/auth/auth-slice';

export const useRefreshToken = () => {
  const dispatch = useAppDispatch();
  const { userData, hydrated } = useAppSelector(selectAuth);
  const token = userData?.accessToken;
  useEffect(() => {
    if (token) {
      http.defaults.headers.common = {
        Authorization: token,
      };
    } else {
      dispatch(signOut());
    }
  }, [dispatch, token]);

  return {
    isLoading: !hydrated,
  };
};
